import { defineStore } from 'pinia';

import { pinia } from './store.js';

// Общее состояние приложения: пользователь, выбранный проект, справочники.
// Всё, что нужно нескольким страницам, живёт здесь; состояние одного экрана —
// в его компоненте.

export const useApp = defineStore('app', {
  state: () => ({
    user: null,
    // Админ сидит под чужим именем: наверху висит полоса, и по ней же он выходит.
    impersonating: false,
    needSetup: false,
    inviteRequired: false,
    activeSession: null,

    // Работает ли агент на машине человека. Нужно только в удалённом режиме,
    // когда приложение висит на сервере, а агент остался у него.
    runner: { required: false, online: false },

    projects: [],
    projectId: Number(localStorage.getItem('hh.project') || 0) || null,

    dictionaries: { tracks: [], grades: [] },
    kinds: [],
    tts: { provider: '', voices: [], speeds: [], voice: '', speed: '1.1' },
    sttReady: false,

    // Настройки голоса переживают перезагрузку страницы.
    voice: localStorage.getItem('hh.voice') || '',
    speed: localStorage.getItem('hh.speed') || '',
  }),
  getters: {
    current: (s) => s.projects.find((p) => p.id === s.projectId) || null,
  },
  actions: {
    setProject(id) {
      this.projectId = id || null;
      if (id) localStorage.setItem('hh.project', String(id));
      else localStorage.removeItem('hh.project');
    },
    setVoice(voice, speed) {
      if (voice !== undefined) { this.voice = voice; localStorage.setItem('hh.voice', voice); }
      if (speed !== undefined) { this.speed = speed; localStorage.setItem('hh.speed', speed); }
    },
  },
});

// За состоянием ходят и обычные модули, не только компоненты, — поэтому рядом
// со стором лежит уже созданный экземпляр. Прежние имена сохранены: менять
// сотню обращений ради формы вызова смысла нет.
export const state = useApp(pinia);
export const setProject = (id) => state.setProject(id);
export const setVoice = (voice, speed) => state.setVoice(voice, speed);
export const currentProject = () => state.current;
